import {useRef} from "react"
import Text from "../../components/input/text";
import Textarea from "../../components/input/textarea";
import Button from "../../components/button";
import Alert from "../../components/alert";
import UseGetFormData from "../../hooks/UseGetFormData";
import {audience_info} from "../../config/tips";
import Select from "../../components/input/select";
import CardMenu from "../../components/card-menu";
import Menu from "./TopMenu";

const AudienceForm = (props) => {
    const {audience, enterprises, errors, isReady, onSubmit} = props
    const formRef = useRef()
    const AudienceMenu = Menu({audience: audience})

    const handleSubmit = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSubmit({
            name         : FormData.get('name'),
            description  : FormData.get('description'),
            id_enterprise: FormData.get('id_enterprise'),
        })
    }


    return (
        <form autoComplete="off" ref={formRef} onSubmit={handleSubmit}>
            <CardMenu {...AudienceMenu} />

            <div className="max-width-600">
                <Alert
                    icon="info"
                    docsPath="/docs/audiences"
                    message={audience_info}
                />

                <Text required
                    size="md"
                    name="name"
                    label="Name"
                    isReady={isReady}
                    error={errors?.name}
                    value={audience?.name}
                    placeholder="Type audience name..."
                />

                <Select required
                    size="md"
                    isReady={isReady}
                    label="Enterprise"
                    name="id_enterprise"
                    options={enterprises}
                    error={errors?.id_enterprise}
                    placeholder="Choose an enterprise"
                    value={audience?.id_enterprise?.$oid}
                />

                <Textarea
                    size="md"
                    isReady={isReady}
                    name="description"
                    label="Description"
                    value={audience?.name}
                    error={errors?.description}
                    placeholder="Type a short description..."
                />

                <Button
                    size="sm"
                    color="primary"
                    isReady={isReady}
                    icon={audience ? 'check' : 'plus'}
                    label={audience ? 'Update' : 'Create'}
                />
            </div>

        </form>
    )
}

export default AudienceForm